import { Icon, IconProps } from "@chakra-ui/react"

const ReportChartIcon = (props: IconProps) => (
  <Icon
    xmlns='http://www.w3.org/2000/svg'
    width='22px'
    height='22px'
    viewBox='0 0 22 22'
    fill='none'
    {...props}
  >
    <path
      d='M7.75 20.75H14.25M7.75 20.75V15.3333M7.75 20.75H1.9C1.72761 20.75 1.56228 20.6815 1.44038 20.5596C1.31848 20.4377 1.25 20.2724 1.25 20.1V15.9833C1.25 15.8109 1.31848 15.6456 1.44038 15.5237C1.56228 15.4018 1.72761 15.3333 1.9 15.3333H7.75M14.25 20.75V7.75M14.25 20.75H20.1C20.2724 20.75 20.4377 20.6815 20.5596 20.5596C20.6815 20.4377 20.75 20.2724 20.75 20.1V1.9C20.75 1.72761 20.6815 1.56228 20.5596 1.44038C20.4377 1.31848 20.2724 1.25 20.1 1.25H14.9C14.7276 1.25 14.5623 1.31848 14.4404 1.44038C14.3185 1.56228 14.25 1.72761 14.25 1.9V7.75M7.75 15.3333V8.4C7.75 8.22761 7.81848 8.06228 7.94038 7.94038C8.06228 7.81848 8.22761 7.75 8.4 7.75H14.25'
      stroke='white'
      strokeWidth='1.5'
    />
  </Icon>
)

export default ReportChartIcon
